export default __webpack_public_path__ + "static/media/blockchain.42f8bc72.svg";